'use client';

import Link from 'next/link';
import { trackEvent } from '../../../lib/analytics/posthog';
import { EVENTS } from '../../../lib/analytics/events';

export default function ProvinceChips({ categorySlug, provinces, basePath }) {
  if (!provinces?.length) return null;

  const linkBase = basePath || `/${categorySlug}`;

  return (
    <div className="flex flex-wrap gap-2">
      {provinces.map((p) => {
        const count = p.count ?? p.total_count;
        return (
          <Link
            key={p.slug}
            href={`${linkBase}/${p.slug}`}
            onClick={() =>
              trackEvent(EVENTS.CATEGORY_PROVINCE_CLICKED, {
                category_slug: categorySlug,
                province: p.province,
                province_slug: p.slug,
                vendor_count: count
              })
            }
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[12px] font-medium text-gray-600 bg-white border border-gray-200 hover:border-gray-300 hover:text-[#1a1a1a] transition-all duration-200"
          >
            {p.province}
            <span className="text-[11px] text-gray-400 tabular-nums">
              ({Number(count).toLocaleString('es-AR')})
            </span>
          </Link>
        );
      })}
    </div>
  );
}
